import { AnalyticReportAccessDTOReportEnum } from '@jooxter/api';
import {
  ANALYTICS_ADOPTION_ROUTE,
  ANALYTICS_BOOKING_ROUTE,
  ANALYTICS_HEATMAP_ROUTE,
  ANALYTICS_OCCUPATION_ROUTE,
  ANALYTICS_TEAM_ROUTE,
} from './routes';

export const REDIRECT_AFTER_LOGIN = 'redir-after-login';
export const rtsmWithCodePattern = new RegExp(/locations\/\d+\/floors\/\d+\/floor_plan\/.+/);
export const realTimeWithCodePattern = new RegExp(/real-time\/.+/);

export enum RouteGroupEnum {
  Analytics = 'analytics',
}

export const keyPathnameMapping: Record<RouteGroupEnum, Record<AnalyticReportAccessDTOReportEnum, string>> = {
  analytics: {
    [AnalyticReportAccessDTOReportEnum.Occupation]: ANALYTICS_OCCUPATION_ROUTE,
    [AnalyticReportAccessDTOReportEnum.Booking]: ANALYTICS_BOOKING_ROUTE,
    [AnalyticReportAccessDTOReportEnum.Adoption]: ANALYTICS_ADOPTION_ROUTE,
    [AnalyticReportAccessDTOReportEnum.Team]: ANALYTICS_TEAM_ROUTE,
    [AnalyticReportAccessDTOReportEnum.Heatmap]: ANALYTICS_HEATMAP_ROUTE,
  },
};
